import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight, X } from "lucide-react";
import { NAV_LINKS } from "../../mock";

export const Wordmark = ({ ink = "", muted = "" }) => (
  <Link to="/" className="group leading-none" data-testid="nav-wordmark">
    <div className={`font-display text-[26px] md:text-[30px] leading-[0.95] tracking-tight ${ink}`}>Medium Plenty</div>
    <div className={`font-label text-[9px] md:text-[10px] mt-1 ${muted}`}>Architecture + Interiors</div>
  </Link>
);

export const DesktopNav = ({ dark, ink, muted }) => {
  const { pathname } = useLocation();
  const hoverInk = dark ? "hover:text-[#ece7db]" : "hover:text-[#23211c]";
  return (
    <nav className="hidden md:flex items-center gap-9" data-testid="desktop-nav">
      {NAV_LINKS.map((l) => {
        const active = pathname === l.to;
        return (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`nav-link-${l.label.toLowerCase()}`}
            className={`font-label text-[11px] flex items-center gap-1 link-underline ${active ? "active" : muted} ${hoverInk} transition-colors`}
          >
            <span className={active ? ink : ""}>{l.label}</span>
            {l.arrow && <ArrowUpRight className="w-3 h-3" strokeWidth={1.5} />}
          </Link>
        );
      })}
    </nav>
  );
};

export const MobileMenu = ({ onClose }) => (
  <div className="fixed inset-0 z-50 mp-dark flex flex-col" data-testid="mobile-menu">
    <div className="px-6 py-6 flex items-start justify-between">
      <Wordmark ink="text-[#ece7db]" muted="text-[#928c7d]" />
      <button onClick={onClose} aria-label="Close menu" data-testid="mobile-menu-close">
        <X className="w-6 h-6 text-[#ece7db]" strokeWidth={1.5} />
      </button>
    </div>
    <nav className="flex-1 flex flex-col justify-center gap-6 px-8">
      {NAV_LINKS.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          onClick={onClose}
          data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
          className="font-display text-[#ece7db] text-4xl flex items-center gap-3"
        >
          {l.label}
          {l.arrow && <ArrowUpRight className="w-6 h-6" strokeWidth={1.2} />}
        </Link>
      ))}
    </nav>
  </div>
);
